import React from 'react';
import { connect } from 'react-redux';
import DataTable from 'react-data-table-component';
import Message from '../layout/Message';
import Button from '../layout/Button';

import {
    fetchPianoTechCompanyList,
    FIND_PIANOTECHCOMPANY_STARTED,
    FIND_PIANOTECHCOMPANY_SUCCEEDED,
    findPianoTechCompany,
} from '../../actions/PianoTechCompanyActions';

import {
    MAINTENANCE_TYPE_VIEW,
    MAINTENANCE_TYPE_ADD,
    defaultPianoTechCompany,
} from '../../app-constants';

const mapStateToProps = state => ({
    pianoTechCompany: state.pianoTechCompany,
    user: state.user,
});

class PianoTechCompanyTable extends React.PureComponent {
    componentDidMount() {
        //Retrieve list if they are not in state
        if (!this.props.pianoTechCompany.pianoTechCompanyList || this.props.pianoTechCompany.pianoTechCompanyList.length === 0)
            this.props.dispatch(fetchPianoTechCompanyList());
    }

    refreshList = () => {
        this.props.dispatch(fetchPianoTechCompanyList());
    }

    addPianoTechCompany = () => {
        const originalPianoTechCompany = Object.assign({}, defaultPianoTechCompany);
        const pianoTechCompany = Object.assign({}, defaultPianoTechCompany);

        this.props.dispatch({
            type: FIND_PIANOTECHCOMPANY_STARTED,
            maintenanceType: MAINTENANCE_TYPE_ADD,
            title: "Add PianoTechCompany",
        });

        this.props.dispatch({
            type: FIND_PIANOTECHCOMPANY_SUCCEEDED,
            pianoTechCompany,
            originalPianoTechCompany,
        });

    }

    viewPianoTechCompany(companyId) {
        this.props.dispatch({
            type: FIND_PIANOTECHCOMPANY_STARTED,
            maintenanceType: MAINTENANCE_TYPE_VIEW,
            title: "View PianoTechCompany",
        });

        this.props.dispatch(findPianoTechCompany(companyId));
    }

    render() {
        const columns = [
            {
                name: 'Company Id',
                selector: row => row.companyId,
                sortable: true,
                width: '10%',
            },
            {
                name: 'Company Name',
                selector: row => row.companyName,
                sortable: true,
                width: '10%',
            },
            {
                name: 'AddressLine1',
                selector: row => row.addressLine1,
                sortable: true,
                width: '10%',
            },
            {
                name: 'AddressLine2',
                selector: row => row.addressLine2,
                sortable: true,
                width: '10%',
            },
            {
                name: 'City',
                selector: row => row.city,
                sortable: true,
                width: '10%',
            },
            {
                name: 'State',
                selector: row => row.state,
                sortable: true,
                width: '10%',
            },
            {
                name: 'Country',
                selector: row => row.country,
                sortable: true,
                width: '10%',
            },
            {
                name: 'Encrypted Phone',
                selector: row => row.encryptedPhone,
                sortable: true,
                width: '10%',
            },
            {
                name: 'Encrypted Tax Id',
                selector: row => row.encryptedTaxId,
                sortable: true,
                width: '10%',
            },
            {
                name: 'Default Minutes Per Appointment',
                selector: row => row.defaultMinutesPerAppointment,
                sortable: true,
                width: '10%',
            },
            {
                name: 'DefaultBeforeAppointmentMinutes',
                selector: row => row.defaultBeforeAppointmentMinutes,
                sortable: true,
                width: '10%',
            },
            {
                name: 'Buttons',
                width: '8%',
                cell: row =>
                (
                    <>
                        <button
                            className="bluebutton"
                            onClick={() => { this.viewPianoTechCompany(row.companyId) }}
                            style={{ marginRight: "5px" }}
                        >View
                        </button>
                    </>
                )
            },
        ]
        const customStyles = {
            rows: {
                style: {
                    minheight: '20px',
                }
            }
        }

        return (
            <div>
                <Message message={this.props.pianoTechCompany.message} type={this.props.pianoTechCompany.messageType} />
                <table width="100%">
                    <tbody>
                        <tr>
                            <td className='lefttext'>
                                <Button className="bluebutton" description="Refresh" onClick={this.refreshList} />
                            </td>
                            {this.props.user.allowAdd &&
                                <td className='righttext'>
                                    <Button className="bluebutton" description="Add PianoTechCompany" onClick={this.addPianoTechCompany} />
                                </td>
                            }
                        </tr>
                    </tbody>
                </table>
                <DataTable
                    title='PianoTechCompany'
                    className='app-table'
                    columns={columns}
                    customStyles={customStyles}
                    striped
                    data={this.props.pianoTechCompany.pianoTechCompanyList}
                    defaultSortField="companyName"
                    highlightOnHover
                    pagination
                    onRowClicked={
                        (row) => { this.viewPianoTechCompany(row.companyId) }
                    }
                />
            </div>
        );
    }

}

export default connect(mapStateToProps)(PianoTechCompanyTable);
